








import Moment from "moment";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ExternalComment } from "../../../../../../domain/document";

@Component
export default class ExternalCommentContent extends Mixins() {
  @Prop()
  comment: ExternalComment;

  get commentText(): string {
    return this.comment.comment;
  }

  get updateInformation(): string {
    // ワークフローのコメント表示に合わせて西暦2桁にしている
    return "最終更新：" + this.comment.updateUserName + "　" + Moment(this.comment.updateDateTime).format("YY/MM/DD HH:mm");
  }
}
